import queryString from 'query-string';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { OrganizationCustomerEnableDto } from 'src/entities/organization/OrganizationCustomerEnableDto';
import OrgCustomerPremiumLevels from 'src/entities/organization/OrgCustomerPremiumLevels';
import {
    SCHEMA_ORGANIZATION_CUSTOMER_PREMIUM_LEVEL_SHAPE,
    SCHEMA_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER_SHAPE,
} from 'src/schemas/Organization';
import callApi, { CallApiResult } from '.';

export type AccountID = 'current' | number;

/* Fetch Registered Events */

// TODO new endpoint?
export const fetchRegisteredEvents = (id: AccountID, partnerId: number): Promise<CallApiResult> => {
    const endpoint = `/academy/v2/${id}/events/${partnerId}`;
    return callApi(endpoint);
};

/* Fetch Video List */

// TODO new endpoint?
export const fetchVideoList = (id: AccountID, partnerId: number): Promise<CallApiResult> => {
    const endpoint = `/academy/v2/${id}/videoList/${partnerId}`;
    return callApi(endpoint);
};

/* Fetch Organization Customer Orders */

// TODO new endpoint?
export const fetchOrganizationCustomerOrders = (
    id: AccountID = 'current',
    partnerId: number,
    pageable: PageableQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/academy/v2/${id}/customerorders/${partnerId}${query}`;
    return callApi(endpoint);
};

/* Fetch Favorites */

// TODO remove
export const fetchOrganizationFavorites = (id: AccountID = 'current'): Promise<CallApiResult> => {
    const endpoint = `/academy/v2/${id}/partnerFavorites`;
    return callApi(endpoint);
};

/* Fetch statsitic */
export const fetchOrganizationStatistic = (id: AccountID = 'current'): Promise<CallApiResult> => {
    const endpoint = `/api/organization/${id}/statistic`;
    return callApi(endpoint);
};

/* Fetch overview */

export const fetchOrganizationOverview = (
    id: AccountID = 'current',
    pageable: PageableQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/api/organization/${id}/overview${query}`;
    return callApi(endpoint);
};

/* Fetch Organization Customers */
export const fetchOrganizationCustomers = (
    id: AccountID = 'current',
    pageable: PageableQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/api/organization/${id}/customers${query}`;
    return callApi(endpoint);
};

/* Fetch Organization Sis Partners */
export const fetchOrganizationSisPartners = (
    id: AccountID = 'current',
    pageable: PageableQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/api/organization/${id}/sisPartners${query}`;
    return callApi(endpoint);
};

/* Fetch Organization Licensors */
export const fetchOrganizationLicensors = (
    id: AccountID = 'current',
    pageable: PageableQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/api/organization/${id}/licensors${query}`;
    return callApi(endpoint);
};

/* Fetch Organization Placements */
export const fetchOrganizationPlacements = (
    id: AccountID = 'current',
    pageable: PageableQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/api/organization/${id}/placements${query}`;
    return callApi(endpoint);
};

/* Fetch Organization Office Profis */
export const fetchOrganizationOfficeProfis = (
    id: AccountID = 'current',
    pageable: PageableQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/api/organization/${id}/officeprofis${query}`;
    return callApi(endpoint);
};

/* Fetch Organization Customer Appliances */
export const fetchOrganizationCustomerAppliances = (
    sourceId: AccountID = 'current',
    targetId: AccountID
): Promise<CallApiResult> => {
    const endpoint = `/api/organization/${sourceId}/customer/${targetId}/appliances`;
    return callApi(endpoint);
};

/* Fetch Organization Customer Data */
export const fetchOrganizationCustomerData = (
    sourceId: AccountID = 'current',
    targetId: AccountID
): Promise<CallApiResult> => {
    const endpoint = `/api/organization/${sourceId}/customer/${targetId}/data`;
    return callApi(endpoint);
};

export const patchOrganizationCustomerData = (
    sourceId: AccountID = 'current',
    targetId: AccountID,
    data: SCHEMA_ORGANIZATION_CUSTOMER_PREMIUM_LEVEL_SHAPE
): Promise<CallApiResult> => {
    const endpoint = `/api/organization/${sourceId}/customer/${targetId}/data`;
    return callApi(endpoint, {
        method: 'PATCH',
        data,
    });
};

/* Fetch Organization Customer Addresses */
export const fetchOrganizationCustomerAddresses = (
    sourceId: AccountID = 'current',
    targetId: AccountID
): Promise<CallApiResult> => {
    const endpoint = `/api/organization/${sourceId}/customer/${targetId}/addresses`;
    return callApi(endpoint);
};

/* Fetch Organization Customer Landingpages */
export const fetchOrganizationCustomerLandingpages = (
    sourceId: AccountID = 'current',
    targetId: AccountID
): Promise<CallApiResult> => {
    const endpoint = `/api/organization/${sourceId}/customer/${targetId}/landingpages`;
    return callApi(endpoint);
};

/* Fetch Organization Customer Referral Partner */
export const fetchOrganizationCustomerReferralPartner = (
    sourceId: AccountID = 'current',
    targetId: AccountID
): Promise<CallApiResult> => {
    const endpoint = `/api/organization/${sourceId}/customer/${targetId}/referralPartner`;
    return callApi(endpoint);
};

export const postOrganizationCustomerReferralPartner = (
    sourceId: AccountID = 'current',
    targetId: AccountID,
    data: SCHEMA_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER_SHAPE
): Promise<CallApiResult> => {
    const endpoint = `/api/organization/${sourceId}/customer/${targetId}/referralPartner`;
    return callApi(endpoint, {
        method: 'POST',
        data,
    });
};

/* Fetch Organization Customer Enables */
export const fetchOrganizationCustomerEnables = (
    sourceId: AccountID = 'current',
    targetId: AccountID
): Promise<CallApiResult> => {
    const endpoint = `/api/organization/${sourceId}/customer/${targetId}/enables`;
    return callApi(endpoint);
};

export const postOrganizationCustomerEnables = (
    sourceId: AccountID = 'current',
    targetId: AccountID,
    data: OrganizationCustomerEnableDto[]
): Promise<CallApiResult> => {
    const endpoint = `/api/organization/${sourceId}/customer/${targetId}/enables`;
    return callApi(endpoint, {
        method: 'POST',
        data: data.map(dto => ({
            state: dto.state,
            group: dto.group,
            type: dto.type,
            createdAt: null,
            enabledUntil: null,
        })),
    });
};

export const postOrganizationCustomerLandingpageEnable = (
    sourceId: AccountID = 'current',
    targetId: AccountID
): Promise<CallApiResult> => {
    const endpoint = `/api/organization/${sourceId}/customer/${targetId}/landingpages/enable`;
    return callApi(endpoint, {
        method: 'POST',
    });
};

/* Insert/Change Customer Premium Level */
export const applyCustomerPremiumLevel = (customerPremiumLevels: OrgCustomerPremiumLevels): Promise<CallApiResult> => {
    const endpoint = '/api/organization/customerPremiumLevel';
    return callApi(endpoint, { method: 'PUT', data: customerPremiumLevels });
};
